import { Link } from 'react-router-dom';

// New logo image URL
const LOGO_URL = "https://customer-assets.emergentagent.com/job_member-hub-104/artifacts/mnjq1cak_Recovery%20Room%20Archive-07.png";

const MainFooter = () => {
    return (
        <footer className="py-12 px-6 bg-[#3D4435] border-t border-[#5A6350]">
            <div className="max-w-6xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
                    {/* Brand */}
                    <div>
                        <div className="flex items-center gap-3 mb-4">
                            <img src={LOGO_URL} alt="Recovery Room Logo" className="w-10 h-10 object-contain" />
                            <h3 className="text-xl font-bold text-white font-['Playfair_Display']">Recovery Room</h3>
                        </div>
                        <p className="text-[#A0A0A0] text-sm">
                            A safe space for Black men. Where healing begins, brotherhood thrives, and purpose is discovered.
                        </p>
                    </div>

                    {/* Who We Are */}
                    <div>
                        <h4 className="text-white font-semibold mb-4">Who We Are</h4>
                        <div className="space-y-2">
                            <Link to="/who-we-are/founder" className="block text-[#A0A0A0] hover:text-[#C9A227] text-sm">
                                Meet the Founder
                            </Link>
                            <Link to="/who-we-are/team" className="block text-[#A0A0A0] hover:text-[#C9A227] text-sm">
                                Our Team
                            </Link>
                            <Link to="/who-we-are/story" className="block text-[#A0A0A0] hover:text-[#C9A227] text-sm">
                                Our Story
                            </Link>
                        </div>
                    </div>

                    {/* Community */}
                    <div>
                        <h4 className="text-white font-semibold mb-4">In The Community</h4>
                        <div className="space-y-2">
                            <Link to="/community/events" className="block text-[#A0A0A0] hover:text-[#C9A227] text-sm">
                                Events
                            </Link>
                            <Link to="/community/resources" className="block text-[#A0A0A0] hover:text-[#C9A227] text-sm">
                                Resources
                            </Link>
                            <Link to="/community/newsletter" className="block text-[#A0A0A0] hover:text-[#C9A227] text-sm">
                                Newsletter
                            </Link>
                            <Link to="/community/connect" className="block text-[#A0A0A0] hover:text-[#C9A227] text-sm">
                                Community
                            </Link>
                            <a href="https://www.paypal.com/donate/?hosted_button_id=F3BSD37A8WSJQ" target="_blank" rel="noopener noreferrer" className="block text-[#A0A0A0] hover:text-[#C9A227] text-sm">
                                Donate
                            </a>
                        </div>
                    </div>

                    {/* Connect With Us */}
                    <div>
                        <h4 className="text-white font-semibold mb-4">Connect With Us</h4>
                        <div className="space-y-2">
                            <a href="https://www.instagram.com/recoveredbrother" target="_blank" rel="noopener noreferrer" className="block text-[#A0A0A0] hover:text-[#C9A227] text-sm">
                                Instagram @recoveredbrother
                            </a>
                            <a href="https://www.facebook.com/recoveredbrother" target="_blank" rel="noopener noreferrer" className="block text-[#A0A0A0] hover:text-[#C9A227] text-sm">
                                Facebook
                            </a>
                            <a href="https://www.linkedin.com/in/peopleequityinvestor/" target="_blank" rel="noopener noreferrer" className="block text-[#A0A0A0] hover:text-[#C9A227] text-sm">
                                LinkedIn
                            </a>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="border-t border-[#5A6350] pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
                    <p className="text-[#666] text-sm">
                        &copy; 2026 Recovery Room. All rights reserved.
                    </p>
                    <div className="flex items-center gap-4">
                        <Link to="/member/register" className="text-[#A0A0A0] hover:text-[#C9A227] text-sm">
                            Become a Member
                        </Link>
                        <span className="text-[#5A6350]">|</span>
                        <Link 
                            to="/login" 
                            className="text-[#666] hover:text-[#A0A0A0] text-sm"
                            data-testid="footer-admin-link"
                        >
                            Admin Login
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default MainFooter;
